import React, { useEffect, useState } from "react";
import ContatoForm from "./ContatoForm";
import { FiPhone, FiMail, FiMapPin } from "react-icons/fi";

// SEO Meta Component OTIMIZADO
const SEOHead = () => {
  useEffect(() => {
    // Configuração do título da página
    document.title = "Dygito - Soluções em Engenharia de Dados, Business Intelligence e IA";
    
    // Meta description OTIMIZADA
    const metaDescription = document.querySelector('meta[name="description"]') || document.createElement('meta');
    metaDescription.name = "description";
    metaDescription.content = "Especialistas em Engenharia de Dados, Business Intelligence, IA e Gestão de Projetos com 15 anos de experiência em Londrina-PR. Representantes exclusivos BIMachine. Transformamos dados em valor para seu negócio.";
    if (!document.querySelector('meta[name="description"]')) {
      document.head.appendChild(metaDescription);
    }

    // Meta keywords OTIMIZADAS
    const metaKeywords = document.querySelector('meta[name="keywords"]') || document.createElement('meta');
    metaKeywords.name = "keywords";
    metaKeywords.content = "engenharia de dados Londrina, business intelligence Paraná, BI Londrina, inteligência artificial PR, gestão de projetos dados, automação de processos, outsourcing TI, BIMachine, Power BI consultoria, Qlik Sense, Google Cloud, dashboard, analytics, indicadores, consultoria dados, visualização dados";
    if (!document.querySelector('meta[name="keywords"]')) {
      document.head.appendChild(metaKeywords);
    }

    // Open Graph OTIMIZADO
    const ogTitle = document.querySelector('meta[property="og:title"]') || document.createElement('meta');
    ogTitle.setAttribute('property', 'og:title');
    ogTitle.content = "Dygito - Especialistas em Dados e Business Intelligence | Londrina-PR";
    if (!document.querySelector('meta[property="og:title"]')) {
      document.head.appendChild(ogTitle);
    }

    const ogDescription = document.querySelector('meta[property="og:description"]') || document.createElement('meta');
    ogDescription.setAttribute('property', 'og:description');
    ogDescription.content = "15 anos transformando dados em valor para negócios. Engenharia de Dados, BI, IA e Gestão de Projetos. Representantes BIMachine em Londrina-PR.";
    if (!document.querySelector('meta[property="og:description"]')) {
      document.head.appendChild(ogDescription);
    }

    // Structured Data COMPLETO E OTIMIZADO
    const structuredData = {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "Organization",
          "@id": "https://www.dygito.com.br/#organization",
          "name": "Dygito",
          "alternateName": "Dygito Soluções Integradas",
          "description": "Especialista em soluções de engenharia de dados, Business Intelligence, Inteligência Artificial e gestão de projetos com 15 anos de experiência em Londrina-PR",
          "url": "https://www.dygito.com.br",
          "logo": {
            "@type": "ImageObject",
            "url": "https://www.dygito.com.br/dygito.png",
            "width": 400,
            "height": 100
          },
          "image": {
            "@type": "ImageObject", 
            "url": "https://www.dygito.com.br/og-image.jpg",
            "width": 1200,
            "height": 630
          },
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "Av. Ayrton Senna da Silva, 760, Loja B",
            "addressLocality": "Londrina",
            "addressRegion": "PR",
            "postalCode": "86050-460",
            "addressCountry": "BR"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": -23.3045,
            "longitude": -51.1696
          },
          "contactPoint": [
            {
              "@type": "ContactPoint",
              "telephone": "+55-43-3322-7627",
              "contactType": "customer service",
              "email": "contato@dygito.com.br",
              "availableLanguage": "Portuguese",
              "areaServed": "BR"
            }
          ],
          "sameAs": [
            "https://wa.me/554333227627",
            "https://www.linkedin.com/company/dygito"
          ],
          "foundingDate": "2009",
          "numberOfEmployees": "10-50",
          "areaServed": {
            "@type": "Country",
            "name": "Brasil"
          },
          "serviceType": [
            "Engenharia de Dados",
            "Business Intelligence", 
            "Inteligência Artificial",
            "Gestão de Projetos",
            "Automação de Processos",
            "Outsourcing"
          ],
          "knowsAbout": [
            "Engenharia de Dados",
            "Business Intelligence",
            "Power BI",
            "Qlik Sense", 
            "Google Cloud",
            "BIMachine",
            "Dashboard",
            "Analytics"
          ]
        },
        {
          "@type": "LocalBusiness",
          "@id": "https://www.dygito.com.br/#localbusiness",
          "name": "Dygito",
          "description": "Especialistas em Engenharia de Dados e Business Intelligence em Londrina-PR",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "Av. Ayrton Senna da Silva, 760, Loja B",
            "addressLocality": "Londrina",
            "addressRegion": "Paraná",
            "postalCode": "86050-460", 
            "addressCountry": "Brasil"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": -23.3045,
            "longitude": -51.1696
          },
          "telephone": "+554333227627",
          "email": "contato@dygito.com.br",
          "url": "https://www.dygito.com.br",
          "openingHoursSpecification": {
            "@type": "OpeningHoursSpecification",
            "dayOfWeek": [
              "Monday", "Tuesday", "Wednesday", "Thursday", "Friday"
            ],
            "opens": "08:00",
            "closes": "18:00"
          },
          "priceRange": "$$"
        },
        {
          "@type": "WebSite",
          "@id": "https://www.dygito.com.br/#website",
          "url": "https://www.dygito.com.br",
          "name": "Dygito - Engenharia de Dados e Business Intelligence",
          "publisher": {
            "@id": "https://www.dygito.com.br/#organization"
          },
          "inLanguage": "pt-BR"
        }
      ]
    };

    // Remover schema antigo e adicionar o novo
    const oldSchema = document.querySelector('script[type="application/ld+json"]');
    if (oldSchema) {
      oldSchema.remove();
    }
    
    const jsonLd = document.createElement('script');
    jsonLd.type = 'application/ld+json';
    jsonLd.textContent = JSON.stringify(structuredData);
    document.head.appendChild(jsonLd);

    // Canonical URL
    const canonical = document.querySelector('link[rel="canonical"]') || document.createElement('link');
    canonical.rel = "canonical";
    canonical.href = "https://www.dygito.com.br/";
    if (!document.querySelector('link[rel="canonical"]')) {
      document.head.appendChild(canonical);
    }

    // Language
    document.documentElement.lang = "pt-BR";

    // Adicionar breadcrumb structured data
    const breadcrumbSchema = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Home",
          "item": "https://www.dygito.com.br/"
        }
      ]
    };

    const breadcrumbScript = document.createElement('script');
    breadcrumbScript.type = 'application/ld+json';
    breadcrumbScript.textContent = JSON.stringify(breadcrumbSchema);
    document.head.appendChild(breadcrumbScript);

    // Adicionar alternates para internacionalização futura
    const alternatePtBr = document.createElement('link');
    alternatePtBr.rel = 'alternate';
    alternatePtBr.hreflang = 'pt-br';
    alternatePtBr.href = 'https://www.dygito.com.br/';
    document.head.appendChild(alternatePtBr);

    const alternateDefault = document.createElement('link');
    alternateDefault.rel = 'alternate';
    alternateDefault.hreflang = 'x-default';
    alternateDefault.href = 'https://www.dygito.com.br/';
    document.head.appendChild(alternateDefault);

  }, []);

  return null;
};

// Componente Counter otimizado
const Counter = ({ value, label, icon }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let start = 0;
    const end = value;
    if (start === end) return;

    const duration = 1500;
    const increment = Math.floor(duration / end) || 1;
    
    const timer = setInterval(() => {
      start += 1;
      setCount(start);
      if (start === end) clearInterval(timer);
    }, increment);

    return () => clearInterval(timer);
  }, [value]);

  return (
    <div className="flex flex-col items-center text-blue-600" itemScope itemType="https://schema.org/QuantitativeValue">
      <div className="mb-2" aria-hidden="true">{icon}</div>
      <div className="text-3xl font-bold" itemProp="value">
        {count}
        {value >= 1000 ? "+" : ""}
      </div>
      <div className="text-sm uppercase text-center" itemProp="name">{label}</div>
    </div>
  );
};

// ServiceCard otimizado com microdata
const ServiceCard = ({ name, icon, description }) => (
  <article 
    className="bg-white p-6 rounded-xl shadow hover:shadow-lg transition-shadow"
    itemScope 
    itemType="https://schema.org/Service"
  >
    <div aria-hidden="true">{icon}</div>
    <h4 className="text-xl font-bold mb-2 text-blue-700" itemProp="name">{name}</h4>
    <p className="text-gray-600" itemProp="description">{description}</p>
  </article>
);

// Dados dos serviços organizados
const servicesData = [
  {
    name: "Engenharia de Dados",
    icon: (
      <div className="flex items-center justify-center w-16 h-16 rounded-full bg-blue-100 mb-4 mx-auto">
        <svg xmlns="http://www.w3.org/2000/svg" className="w-8 h-8 text-blue-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-label="Ícone Engenharia de Dados">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 7v10c0 2.21 3.582 4 8 4s8-1.79 8-4V7M4 7c0 2.21 3.582 4 8 4s8-1.79 8-4M4 7c0-2.21 3.582-4 8-4s8 1.79 8 4m0 5c0 2.21-3.582 4-8 4s-8-1.79-8-4" />
        </svg>
      </div>
    ),
    description: "Arquitetamos, estruturamos e entregamos dados prontos para decisões estratégicas em escala com as melhores práticas de engenharia.",
  },
  {
    name: "Business Intelligence",
    icon: (
      <div className="flex items-center justify-center w-16 h-16 rounded-full bg-blue-100 mb-4 mx-auto">
        <svg xmlns="http://www.w3.org/2000/svg" className="w-8 h-8 text-blue-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-label="Ícone Business Intelligence">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
        </svg>
      </div>
    ),
    description: "Transformamos dados em dashboards interativos e relatórios que geram insights valiosos e apoiam decisões ágeis e estratégicas.",
  },
  {
    name: "Outsourcing",
    icon: (
      <div className="flex items-center justify-center w-16 h-16 rounded-full bg-blue-100 mb-4 mx-auto">
        <svg xmlns="http://www.w3.org/2000/svg" className="w-8 h-8 text-blue-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-label="Ícone Outsourcing">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M9 20H4v-2a3 3 0 015.356-1.857M15 11a4 4 0 11-8 0 4 4 0 018 0zm6 0a2 2 0 11-4 0 2 2 0 014 0zm-16 0a2 2 0 11-4 0 2 2 0 014 0z" />
        </svg>
      </div>
    ),
    description: "Alocamos profissionais especializados em dados e BI para ampliar sua equipe com agilidade, expertise e eficiência comprovada.",
  },
  {
    name: "Inteligência Artificial",
    icon: (
      <div className="flex items-center justify-center w-16 h-16 rounded-full bg-blue-100 mb-4 mx-auto">
        <svg xmlns="http://www.w3.org/2000/svg" className="w-8 h-8 text-blue-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-label="Ícone Inteligência Artificial">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
        </svg>
      </div>
    ),
    description: "Aplicamos IA e Machine Learning para automatizar processos, prever comportamentos e otimizar operações do seu negócio.",
  },
  {
    name: "Gestão de Projetos",
    icon: (
      <div className="flex items-center justify-center w-16 h-16 rounded-full bg-blue-100 mb-4 mx-auto">
        <svg xmlns="http://www.w3.org/2000/svg" className="w-8 h-8 text-blue-500" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-label="Ícone Gestão de Projetos">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" />
        </svg>
      </div>
    ),
    description: "Planejamos, executamos e entregamos projetos de tecnologia e dados com metodologia ágil, cumprindo prazo e qualidade.",
  },
  {
    name: "Automação de Processos",
    icon: (
      <div className="flex items-center justify-center w-16 h-16 rounded-full bg-blue-100 mb-4 mx-auto">
        <svg xmlns="http://www.w3.org/2000/svg" className="w-8 h-8 text-blue-500" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} aria-label="Ícone Automação de Processos">
          <path strokeLinecap="round" strokeLinejoin="round" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
          <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
        </svg>
      </div>
    ),
    description: "Redesenhamos fluxos de trabalho e implementamos soluções automatizadas para ganho de tempo e produtividade para seu negócio.",
  }
];

// Dados dos contadores
const countersData = [
  {
    value: 15,
    label: "Anos transformando dados em valor",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" className="w-10 h-10" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-label="15 anos de experiência">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    )
  },
  {
    value: 50,
    label: "Clientes atendidos",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" className="w-10 h-10" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-label="1 usuário">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
      </svg>
    )
  },
  {
    value: 1000,
    label: "Pessoas impactadas",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" className="w-10 h-10" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-label="1000 pessoas impactadas">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M9 20H4v-2a3 3 0 015.356-1.857M15 11a4 4 0 10-8 0 4 4 0 008 0zm6 0a2 2 0 11-4 0 2 2 0 014 0z" />
      </svg>
    )
  },
  {
    value: 200,
    label: "Projetos entregues",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" className="w-10 h-10" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-label="200 projetos realizados">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" />
      </svg>
    )
  }
];

// Lista dos diferenciais
const differentialsList = [
  "Jornada Analítica Completa",
  "Especialistas em Multiplataformas", 
  "Soluções Personalizadas",
  "Time Sênior e Multidisciplinar",
  "Alta Performance em Projetos",
  "Cultura Data-Driven",
  "Escalabilidade e Governança",
  "Parcerias Estratégicas e Inovação",
];

// Componente Header otimizado
const Header = () => (
  <header className="fixed w-full bg-white shadow z-50 border-b border-gray-200" role="banner">
    <div className="max-w-7xl mx-auto px-4 py-4 flex justify-between items-center">
      <img 
        src="/dygito.png" 
        alt="Dygito - Engenharia de Dados e Business Intelligence" 
        className="h-8" 
        width="120" 
        height="32"
      />
      <div className="flex items-center space-x-6">
        <nav className="hidden md:flex space-x-6 text-sm font-medium" role="navigation" aria-label="Menu principal">
          <a href="#" className="text-blue-500 border-b-2 border-blue-500 pb-1" aria-current="page">
            Home
          </a>
          <a href="#services" className="hover:text-blue-600 hover:border-blue-500 hover:border-b-2 pb-1">
            Serviços
          </a>
          <a href="#bimachine" className="hover:text-blue-600 hover:border-blue-500 hover:border-b-2 pb-1">
            BIMachine
          </a>
          <a href="#about" className="hover:text-blue-600 hover:border-blue-500 hover:border-b-2 pb-1">
            Quem Somos
          </a>
          <a href="#differentials" className="hover:text-blue-600 hover:border-blue-500 hover:border-b-2 pb-1">
            Diferenciais
          </a>
          <a href="#contact" className="hover:text-blue-600 hover:border-blue-500 hover:border-b-2 pb-1">
            Contato
          </a>
        </nav>
        <a
          href="https://register.bimachine.com/dygi"
          target="_blank"
          rel="noopener noreferrer"
          className="hidden md:inline-block bg-blue-600 text-white px-4 py-2 rounded-full hover:bg-blue-700 transition-colors"
          aria-label="Testar BIMachine gratuitamente"
        >
          Testar grátis
        </a>
      </div>
    </div>
  </header>
);

// Componente Hero otimizado com melhor SEO
const Hero = () => (
  <section
    className="relative w-full min-h-screen bg-cover bg-center text-white text-center"
    style={{
      backgroundImage: "url(/representacao-da-experiencia-utilizador-e-design-da-interface.jpg)",
    }}
    itemScope
    itemType="https://schema.org/WebPageElement"
  >
    <div className="absolute inset-0 bg-black bg-opacity-50 flex flex-col justify-center items-center px-4 text-center">
      <h1 className="text-4xl md:text-7xl font-bold mb-4" itemProp="headline">
        Qual seu desafio
        <br />
        de dados?
      </h1>
      <p className="text-xl mb-6">
        Oferecemos soluções em Engenharia de Dados, Business Intelligence,
        Gestão de Projetos e IA.
      </p>
      <a
        href="#contact"
        className="mt-8 bg-blue-600 text-white text-xl px-8 py-4 rounded-full hover:bg-blue-700 transition-colors focus:ring-4 focus:ring-blue-300"
        aria-label="Falar com especialista em dados"
      >
        Fale com um especialista
      </a>
    </div>
  </section>
);

// Componente About otimizado
const About = () => (
  <section 
    id="about" 
    className="py-20 bg-white text-center" 
    role="main"
    itemScope 
    itemType="https://schema.org/AboutPage"
  >
    <div className="max-w-4xl mx-auto px-4">
      <h2 className="text-3xl font-semibold text-gray-800 mb-6" itemProp="headline">
        Somos Especialistas em Dados
      </h2>
      <div className="text-gray-600 text-lg leading-relaxed" itemProp="text">
        <p className="mb-4">
          A <strong>Dygito</strong> é especialista em soluções de <strong>Engenharia de Dados</strong>, <strong>Business Intelligence</strong>, 
          <strong> Inteligência Artificial</strong> e <strong>Gestão de Projetos</strong> em Londrina e região.
        </p>
        <p className="mb-4">
          Com mais de <strong>15 anos de experiência</strong>, entregamos resultados comprovados por meio de tecnologia, 
          estratégia e inovação. Somos <strong>representantes exclusivos da plataforma BIMachine</strong> no Paraná.
        </p>
        <p>
          Atuamos em toda a jornada analítica, desde a coleta até a visualização, 
          <strong> transformando dados em valor real para o seu negócio</strong>.
        </p>
      </div>
    </div>
    <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 max-w-5xl mx-auto px-4">
      {countersData.map((counter, index) => (
        <Counter
          key={index}
          value={counter.value}
          label={counter.label}
          icon={counter.icon}
        />
      ))}
    </div>
  </section>
);

// Componente Services otimizado
const Services = () => (
  <section 
    id="services" 
    className="py-20 bg-gray-50 text-center"
    itemScope 
    itemType="https://schema.org/ItemList"
  >
    <div className="max-w-6xl mx-auto px-4">
      <h2 className="text-3xl font-semibold text-gray-800 mb-4" itemProp="name">
        Nossos Serviços Especializados
      </h2>
      <p className="text-gray-600 mb-10 text-lg max-w-3xl mx-auto">
        Oferecemos soluções completas em dados e tecnologia para empresas que buscam 
        transformação digital e decisões baseadas em dados.
      </p>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
        {servicesData.map((service, index) => (
          <div key={index} itemProp="itemListElement" itemScope itemType="https://schema.org/ListItem">
            <meta itemProp="position" content={index + 1} />
            <ServiceCard
              name={service.name}
              icon={service.icon}
              description={service.description}
            />
          </div>
        ))}
      </div>
    </div>
  </section>
);

// Componente BIMachine otimizado
const BIMachine = () => (
  <section 
    id="bimachine" 
    className="relative py-20 bg-blue-800 text-center overflow-hidden"
    itemScope 
    itemType="https://schema.org/Service"
  >
    <img
      src="https://static.wixstatic.com/media/93c381_e5a74ea5fe16470eaaa594813e0ea164~mv2_d_1737_1915_s_2.png/v1/fill/w_938,h_1040,al_c,q_90,usm_0.66_1.00_0.01,enc_avif,quality_auto/notebook.png"
      alt="Plataforma BIMachine - Business Intelligence no notebook"
      className="absolute -z-10 top-1/2 right-0 transform -translate-y-1/2 hidden md:block"
      style={{ width: "350px", height: "388px" }}
      width="350"
      height="388"
    />
    <div className="relative z-10 w-full px-8 py-12 text-white max-w-4xl mx-auto">
      <h2 className="text-3xl font-semibold mb-4" itemProp="name">
        BIMachine - Nossa Solução Exclusiva em BI
      </h2>
      <div className="mb-6" itemProp="description">
        <p className="mb-4 text-lg">
          Somos <strong>representantes exclusivos da plataforma BIMachine</strong>,<br />
          com expertise completa na sua implantação, integração e sustentação.
        </p>
      </div>
      <div itemProp="provider" itemScope itemType="https://schema.org/Organization" className="hidden">
        <span itemProp="name">Dygito</span>
      </div>
      <a
        href="https://register.bimachine.com/dygi"
        target="_blank"
        rel="noopener noreferrer"
        className="bg-blue-500 hover:bg-blue-600 transition-colors text-white px-8 py-3 rounded-full inline-block text-lg font-medium focus:ring-4 focus:ring-blue-300"
        aria-label="Solicitar demonstração gratuita da BIMachine"
        itemProp="url"
      >
        Solicite uma demonstração gratuita
      </a>
    </div>
  </section>
);

// Componente Differentials otimizado
const Differentials = () => (
  <section id="differentials" className="py-20 bg-gray-50 text-center">
    <div className="max-w-7xl mx-auto px-4">
      <h2 className="text-3xl font-semibold text-gray-800 mb-4">
        Por que escolher a Dygito?
      </h2>
      <p className="text-gray-600 mb-10 text-lg max-w-3xl mx-auto">
        Nossa experiência de 15 anos nos permite oferecer soluções completas e personalizadas 
        para cada desafio de dados do seu negócio.
      </p>
     <div className="max-w-6xl mx-auto px-4 flex flex-col md:flex-row items-center gap-10">
      <div className="w-full md:w-1/2 flex justify-center">
        <img
          src="/jornada.png"
          alt="Jornada Analítica Completa - Da coleta à análise de dados"
          className="h-[500px] max-w-full object-contain rounded-lg shadow-lg"
        />
      </div>
      <div className="w-full md:w-1/2 flex flex-col gap-6 text-left">
        <p className="text-2xl font-semibold text-blue-800">
          Nosso time percorre toda a jornada analítica!
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {differentialsList.map((item, idx) => (
            <div key={idx} className="bg-white p-6 rounded-xl shadow text-left hover:shadow-lg transition-shadow">
              <p className="text-gray-600">{item}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
    </div>
  </section>
);

// Componente WhatsAppButton otimizado
const WhatsAppButton = () => (
  <a
    href="https://wa.me/554333227627"
    className="fixed bottom-6 right-6 z-50"
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Conversar no WhatsApp - (43) 3322-7627"
  >
    <div className="relative w-14 h-14">
      <span className="absolute inset-0 rounded-full bg-green-500 opacity-75 animate-wave"></span>
      <div className="absolute inset-0 bg-green-500 hover:bg-green-600 text-white rounded-full flex items-center justify-center shadow-lg transition-all duration-300">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-6 w-6"
          viewBox="0 0 32 32"
          fill="currentColor"
          aria-hidden="true"
        >
          <path d="M16.004 0C7.165 0 0 7.163 0 16c0 2.82.735 5.585 2.133 8.012L0 32l8.195-2.117A15.902 15.902 0 0016.004 32C24.84 32 32 24.837 32 16S24.84 0 16.004 0zm8.677 23.127c-.36 1.004-2.112 1.934-2.89 2.064-.743.117-1.675.166-2.692-.205-.618-.215-1.412-.46-2.441-.899-4.297-1.858-7.104-6.426-7.32-6.721-.215-.296-1.747-2.33-1.747-4.445 0-2.115 1.1-3.155 1.492-3.574.392-.418.857-.523 1.14-.523.296 0 .57.003.818.014.265.012.62-.1.973.746.36.863 1.223 2.986 1.33 3.201.108.215.18.466.035.748-.144.282-.215.458-.42.705-.206.247-.441.552-.63.742-.206.206-.42.43-.18.86.24.43 1.066 1.76 2.28 2.85 1.568 1.396 2.89 1.83 3.32 2.035.43.205.68.18.938-.11.26-.29 1.073-1.248 1.36-1.675.282-.428.582-.354.973-.215.392.138 2.487 1.172 2.918 1.386.43.215.715.319.818.497.108.173.108 1.005-.252 2.01z" />
        </svg>
      </div>
    </div>
  </a>
);

// Componente Footer otimizado
const Footer = () => (
  <footer style={{ backgroundColor: "#1c2039" }} className="text-white py-10 mt-20" role="contentinfo">
    <div className="max-w-6xl mx-auto grid grid-cols-2 md:grid-cols-5 gap-6 px-4">
      <div className="col-span-2">
        <h3 className="text-xl font-bold mb-2">Dygito</h3>
        <p className="text-sm">
          De ponta a ponta da jornada analítica,<br />
          da Engenharia de Dados ao Business Intelligence<br />
          e da Gestão de Projetos à Inteligência Artificial.
        </p>
      </div>

      <div>
        <h4 className="font-semibold mb-2">Serviços</h4>
        <ul className="text-sm space-y-1" role="list">
          <li>Engenharia de Dados</li>
          <li>Business Intelligence</li>
          <li>Outsourcing</li>
          <li>Inteligência Artificial</li>
          <li>Gestão de Projetos</li>
          <li>Automação de Processos</li>
        </ul>
      </div>

      <div>
        <h4 className="font-semibold mb-2">Plataformas</h4>
        <ul className="text-sm space-y-1" role="list">
          <li>Google Cloud</li>
          <li>Qlik Sense</li>
          <li>Power BI</li>
          <li>BIMachine</li>
        </ul>
      </div>

      <div>
        <h4 className="font-semibold mb-2">Contato</h4>
        <address className="text-sm space-y-3 not-italic">
          <div className="flex items-start gap-2">
            <svg className="w-4 h-4 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
            </svg>
            <a href="tel:+554333227627" className="hover:text-blue-300">(43) 3322-7627</a>
          </div>
          <div className="flex items-start gap-2">
            <svg className="w-4 h-4 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
            </svg>
            <a href="mailto:contato@dygito.com.br" className="hover:text-blue-300">contato@dygito.com.br</a>
          </div>
          <div className="flex items-start gap-2">
            <svg className="w-4 h-4 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
            </svg>
            <span>
              Av. Ayrton Senna da Silva, 760<br />
              Loja B | Gleba Palhano<br />
              Londrina - PR
            </span>
          </div>
        </address>
      </div>
    </div>

    <div className="mt-8 pt-8 border-t border-gray-700 text-center text-sm text-gray-400">
      <p>
        © 2025 <strong>DYGITO</strong> - Todos os direitos reservados. | 
        Especialistas em Dados
      </p>
      <p className="mt-2">
        <span>Engenharia de Dados</span> • <span>Business Intelligence</span> • <span>IA</span> • <span>Gestão de Projetos</span>
      </p>
    </div>
  </footer>
);

// Componente principal App otimizado
export default function App() {
  // Effect para monitorar performance e enviar para analytics
  useEffect(() => {
    // Monitorar tempo de carregamento
    window.addEventListener('load', () => {
      if (typeof window.gtag !== 'undefined') {
        window.gtag('event', 'page_load_time', {
          event_category: 'performance',
          event_label: 'complete',
          value: Math.round(performance.now())
        });
      }
    });

    // Monitorar scroll depth para SEO
    let maxScroll = 0;
    const handleScroll = () => {
      const scrollPercent = Math.round(
        (window.scrollY / (document.documentElement.scrollHeight - window.innerHeight)) * 100
      );
      
      if (scrollPercent > maxScroll) {
        maxScroll = scrollPercent;
        
        // Marcos importantes para analytics
        if ([25, 50, 75, 100].includes(scrollPercent)) {
          if (typeof window.gtag !== 'undefined') {
            window.gtag('event', 'scroll_depth', {
              event_category: 'engagement',
              event_label: `${scrollPercent}%`,
              value: scrollPercent
            });
          }
        }
      }
    };

    let scrollTimeout;
    window.addEventListener('scroll', () => {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(handleScroll, 100);
    });

    // Rastrear cliques em links importantes
    const trackClick = (element, label) => {
      element.addEventListener('click', () => {
        if (typeof window.gtag !== 'undefined') {
          window.gtag('event', 'click', {
            event_category: 'engagement',
            event_label: label
          });
        }
      });
    };

    // Rastrear cliques importantes
    setTimeout(() => {
      const whatsappBtn = document.querySelector('a[href*="wa.me"]');
      const contactBtn = document.querySelector('a[href="#contact"]');
      const bimachineBtn = document.querySelector('a[href*="bimachine.com"]');

      if (whatsappBtn) trackClick(whatsappBtn, 'whatsapp_click');
      if (contactBtn) trackClick(contactBtn, 'contact_click');  
      if (bimachineBtn) trackClick(bimachineBtn, 'bimachine_click');
    }, 1000);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div className="font-sans" itemScope itemType="https://schema.org/WebPage">
      <SEOHead />
      
      {/* Breadcrumb invisível para SEO */}
      <nav aria-label="Breadcrumb" className="sr-only">
        <ol itemScope itemType="https://schema.org/BreadcrumbList">
          <li itemProp="itemListElement" itemScope itemType="https://schema.org/ListItem">
            <a itemProp="item" href="https://www.dygito.com.br/">
              <span itemProp="name">Home</span>
            </a>
            <meta itemProp="position" content="1" />
          </li>
        </ol>
      </nav>

      <Header />
      <main role="main">
        <Hero />
        <About />
        <Services />
        <BIMachine />
        <Differentials />
        <ContatoForm />
      </main>
      <WhatsAppButton />
      <Footer />

      {/* Schema adicional para FAQ (caso queira adicionar) */}
      <script type="application/ld+json" dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          "mainEntity": [
            {
              "@type": "Question", 
              "name": "O que é Engenharia de Dados?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Engenharia de Dados é a disciplina que cuida da coleta, processamento e estruturação de dados para análise. Na Dygito, arquitetamos pipelines de dados robustos e escaláveis."
              }
            },
            {
              "@type": "Question",
              "name": "Vocês atendem empresas fora de Londrina?", 
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Sim! Embora nossa sede seja em Londrina-PR, atendemos clientes em todo o Brasil com nossos serviços de BI, Engenharia de Dados e IA."
              }
            },
            {
              "@type": "Question",
              "name": "O que é a plataforma BIMachine?",
              "acceptedAnswer": {
                "@type": "Answer", 
                "text": "BIMachine é uma plataforma completa de Business Intelligence. Somos representantes exclusivos em Londrina, oferecendo implantação, treinamento e suporte técnico."
              }
            }
          ]
        })
      }} />
    </div>
  );
}